import { render, staticRenderFns } from "./BodyPartUpdate.vue?vue&type=template&id=f8996fe4&"
import script from "./BodyPartUpdate.vue?vue&type=script&lang=js&"
export * from "./BodyPartUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports